export const SERVICE_TYPE = {
    CALLBACK: 'CALLBACK',
    PURCHASE: 'PURCHASE',
    SEND_MAIL: 'SEND_MAIL'
};



// WEBPACK FOOTER //
// ./src/constants/Order.js